@file:OptIn(InternalResourceApi::class)

package tregz.robbins.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tregz.robbins.generated.resources/"

@delegate:ResourceContentHash(-1_009_112_913)
public val Res.drawable.bacwhite: DrawableResource by lazy {
      DrawableResource("drawable:bacwhite", setOf(
        ResourceItem(setOf(), "${MD}drawable/bacwhite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(574_223_575)
public val Res.drawable.banana1: DrawableResource by lazy {
      DrawableResource("drawable:banana1", setOf(
        ResourceItem(setOf(), "${MD}drawable/banana1.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_102_981_355)
public val Res.drawable.banana2: DrawableResource by lazy {
      DrawableResource("drawable:banana2", setOf(
        ResourceItem(setOf(), "${MD}drawable/banana2.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(738_263_772)
public val Res.drawable.fishing1: DrawableResource by lazy {
      DrawableResource("drawable:fishing1", setOf(
        ResourceItem(setOf(), "${MD}drawable/fishing1.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_012_232_836)
public val Res.drawable.fishing2: DrawableResource by lazy {
      DrawableResource("drawable:fishing2", setOf(
        ResourceItem(setOf(), "${MD}drawable/fishing2.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-977_215_616)
public val Res.drawable.flowerz1: DrawableResource by lazy {
      DrawableResource("drawable:flowerz1", setOf(
        ResourceItem(setOf(), "${MD}drawable/flowerz1.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-95_320_107)
public val Res.drawable.flowerz2: DrawableResource by lazy {
      DrawableResource("drawable:flowerz2", setOf(
        ResourceItem(setOf(), "${MD}drawable/flowerz2.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_694_789)
public val Res.drawable.flybird1: DrawableResource by lazy {
      DrawableResource("drawable:flybird1", setOf(
        ResourceItem(setOf(), "${MD}drawable/flybird1.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(971_460_279)
public val Res.drawable.ic_branding: DrawableResource by lazy {
      DrawableResource("drawable:ic_branding", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_branding.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_021_371_459)
public val Res.drawable.ic_logo_red: DrawableResource by lazy {
      DrawableResource("drawable:ic_logo_red", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logo_red.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-632_969_319)
public val Res.drawable.oldship1: DrawableResource by lazy {
      DrawableResource("drawable:oldship1", setOf(
        ResourceItem(setOf(), "${MD}drawable/oldship1.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-389_210_447)
public val Res.drawable.rivieres: DrawableResource by lazy {
      DrawableResource("drawable:rivieres", setOf(
        ResourceItem(setOf(), "${MD}drawable/rivieres.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-910_495_624)
public val Res.drawable.tr012004: DrawableResource by lazy {
      DrawableResource("drawable:tr012004", setOf(
        ResourceItem(setOf(), "${MD}drawable/tr012004.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bacwhite", Res.drawable.bacwhite)
  map.put("banana1", Res.drawable.banana1)
  map.put("banana2", Res.drawable.banana2)
  map.put("fishing1", Res.drawable.fishing1)
  map.put("fishing2", Res.drawable.fishing2)
  map.put("flowerz1", Res.drawable.flowerz1)
  map.put("flowerz2", Res.drawable.flowerz2)
  map.put("flybird1", Res.drawable.flybird1)
  map.put("ic_branding", Res.drawable.ic_branding)
  map.put("ic_logo_red", Res.drawable.ic_logo_red)
  map.put("oldship1", Res.drawable.oldship1)
  map.put("rivieres", Res.drawable.rivieres)
  map.put("tr012004", Res.drawable.tr012004)
}
